import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import Content from '../common/template/content';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import Select from '../common/form/select';
import FormatUtils from '../common/formatUtils/FormatUtils';
import Cookies from 'react-cookies';

import { 
	getLista, getListaTerceiros, getListaEntradas, getListaSaidas, getListaTransferencias, 
	getListaUnidade, getListaProduto , getListaPosicaoVeiculo, getListaManual, getListaEstoqueBase
} from './dashboardPetroshowActions';


const TOKENS = {
	bg: '#f4f6fb',
	cardBg: '#ffffff',
	cardRadius: 16,
	cardShadow: '0 1px 2px rgba(15, 23, 42, 0.04), 0 8px 24px rgba(15, 23, 42, 0.06)',
	border: '#edf0f5',
	textPrimary: '#0f172a',
	textMuted: '#64748b',
	headerGradient: 'linear-gradient(120deg, #43557a 0%, #43557a 60%, #43557a 100%)',
	headerGradientSoft: 'linear-gradient(120deg, #5c719e 0%, #5c719e 100%)',
	accent: '#3b6df4',
};

const PRODUTO_STYLE = {
	1: { bg: '#fef3c7', text: '#92400e', dot: '#d97706', label: 'S10' },     // S10
	3: { bg: '#ffe4d6', text: '#9a3412', dot: '#ea580c', label: 'S500' },    // S500
};

const pillStyle = (bg, text) => ({
	display: 'inline-flex',
	alignItems: 'center',
	justifyContent: 'center',
	gap: 6,
	padding: '5px 12px',
	borderRadius: 999,
	background: bg,
	color: text,
	fontWeight: 600,
	fontSize: 13,
	lineHeight: 1.2,
	whiteSpace: 'nowrap',
	minWidth: 80
});

class DashboardPetroshow extends Component {

	state = {
		pesquisar: '',
		filtro: {
			id_unidades: []
		}
	}

	constructor(props) {
		super(props);
    }

    componentDidMount() {
		this.atualizarLista();

		this.idInterval = setInterval(() => {
			this.atualizarLista();
		}, 60000);
    }

	componentWillMount() {

		const cookieFiltro = Cookies.load('dashboardPetroshowFiltro');

		if (cookieFiltro) {
			this.setState({
				...this.state,
				filtro: {
					...cookieFiltro
				}
			});
		}

	}

	componentWillUnmount() {
		clearInterval(this.idInterval);
	}

	atualizarLista() {
		this.props.getListaUnidade();
		this.props.getListaProduto();
		this.props.getLista();
		this.props.getListaTerceiros();
		this.props.getListaEntradas();
		this.props.getListaSaidas();
		this.props.getListaTransferencias();
		this.props.getListaPosicaoVeiculo();
		this.props.getListaManual();
		this.props.getListaEstoqueBase();
	}

	setFiltro(filtro) {

		Cookies.save('dashboardPetroshowFiltro', JSON.stringify({
			...filtro
		}), { path: '/' });

		this.setState({
			filtro: {
				...filtro
			}
		});

	}

	buscarSaldoEstoqueBase(id_unidade, id_produto) {
		let saldoCalculado = 0;

		const unidadeLocal = [1, 3, 9, 60].includes(id_unidade); //AB, BG, PN, SE

		if (unidadeLocal) {
			this.props.listaEstoqueBase.filter(item => {
				if (!id_unidade || item.id_unidade != id_unidade) {
					return 0;
				}
				if (!id_produto || item.id_produto != id_produto) {
					return 0;
				}
				return true;
			}).forEach(item => {
				//Começa a contar com esse estoque a partir daqui - se houver alterações anteriores não irá aplicar daqui para frente
				if (item.nome_tipo == 'Ajuste de Saldo') {
					saldoCalculado = parseFloat(item.quantidade_estoque);
				} else {
					saldoCalculado += parseFloat(item.quantidade_estoque);
				}
			});
		} else {
			const registroManual = this.props.listaManual.filter(manual => manual.id_unidade == id_unidade && manual.id_produto == id_produto).pop();

			saldoCalculado = parseFloat(registroManual ? registroManual.quantidade : 0);
		}

		return saldoCalculado;
	}

	calcularSaldos(unidade, produto) {
		const registros = this.props.lista.filter(item => item.id_unidade == unidade.id && item.id_produto == produto.id);
		const rodas = registros.find(item => item.status == 'SOBRE RODAS') || {};
		const faturado = registros.find(item => item.status == 'FATURADO (NÃO CARREGADO)') || {};
		const manual = this.props.listaManualPetroshow.filter(item => item.id_unidade == unidade.id && item.id_produto == produto.id).pop();
		const estoqueBase = this.buscarSaldoEstoqueBase(unidade.id, produto.id);
		const sobreRodasBase = parseFloat(rodas.quantidade_sobre_rodas_base || 0);
		// A quantidade sobre rodas já contém a parcela que está na base.
		const sobreRodasViagem = parseFloat(rodas.quantidade || 0) - sobreRodasBase;
		const petroshow = parseFloat(manual ? manual.quantidade : 0);
		const petroshowCustoUnitario = parseFloat(manual && manual.custo_unitario) || 0;
		const petroshowValorTotal = parseFloat(manual && manual.valor_total) || 0;

		return {
			infinitum: estoqueBase + sobreRodasViagem + sobreRodasBase - parseFloat(faturado.quantidade || 0),
			petroshow,
			petroshowCustoUnitario,
			petroshowValorTotal,
			// Preserva a regra de diferença já utilizada nesta dashboard.
			diferenca: estoqueBase + sobreRodasViagem + sobreRodasBase - parseFloat(faturado.quantidade || 0) - petroshow
		};
	}

	renderTabela(linhas) {
		const totais = linhas.reduce((total, linha) => ({
			infinitum: total.infinitum + linha.infinitum,
			petroshow: total.petroshow + linha.petroshow,
			petroshowValorTotal: total.petroshowValorTotal + linha.petroshowValorTotal,
			diferenca: total.diferenca + linha.diferenca
		}), { infinitum: 0, petroshow: 0, petroshowValorTotal: 0, diferenca: 0 });

		return (
			<div className="db-table-wrap">
				<Table responsive>
					<colgroup>
						<col style={{ width: '20%' }} />
						<col style={{ width: '16%' }} />
						<col style={{ width: '16%' }} />
						<col style={{ width: '15%' }} />
						<col style={{ width: '19%' }} />
						<col style={{ width: '14%' }} />
					</colgroup>
					<THead>
						<Tr>
							<Th alignCenter>Produto</Th>
							<Th alignCenter title="Estoque Base + Estoque Sobre Rodas Viagem + Estoque Sobre Rodas Base - Faturado (não carregado)">Estoque Infinitum</Th>
							<Th alignCenter>Estoque Petroshow</Th>
							<Th alignCenter>Custo Unitário</Th>
							<Th alignCenter>Valor Total</Th>
							<Th alignCenter>Diferença</Th>
						</Tr>
					</THead>
					<TBody>
						{linhas.map(linha => {
							const cor = PRODUTO_STYLE[linha.produto.id] || PRODUTO_STYLE[1];
							return (
								<Tr key={linha.produto.id}>
									<Td alignCenter><span style={pillStyle(cor.bg, cor.text)}>{linha.produto.valor}</span></Td>
									<Td alignCenter>{FormatUtils.formatarValorTelaDecimal(linha.infinitum, 0)}</Td>
									<Td alignCenter>{FormatUtils.formatarValorTelaDecimal(linha.petroshow, 0)}</Td>
									<Td alignCenter>R$ {FormatUtils.formatarValorTela(linha.petroshowCustoUnitario, 4)}</Td>
									<Td alignCenter>R$ {FormatUtils.formatarValorTelaDecimal(linha.petroshowValorTotal, 2)}</Td>
									<Td alignCenter>{FormatUtils.formatarValorTelaDecimal(linha.diferenca, 0)}</Td>
								</Tr>
							);
						})}
						<Tr backgroundColor={'#f8fafc'}>
							<Td alignRight bold fontSize={15}>TOTAL</Td>
							<Td alignCenter bold fontSize={15}>{FormatUtils.formatarValorTelaDecimal(totais.infinitum, 0)}</Td>
							<Td alignCenter bold fontSize={15}>{FormatUtils.formatarValorTelaDecimal(totais.petroshow, 0)}</Td>
							<Td alignCenter bold fontSize={15}>R$ {FormatUtils.formatarValorTela(totais.petroshow > 0 ? totais.petroshowValorTotal / totais.petroshow : 0, 4)}</Td>
							<Td alignCenter bold fontSize={15}>R$ {FormatUtils.formatarValorTelaDecimal(totais.petroshowValorTotal, 2)}</Td>
							<Td alignCenter bold fontSize={15}>{FormatUtils.formatarValorTelaDecimal(totais.infinitum - totais.petroshow, 0)}</Td>
						</Tr>
					</TBody>
				</Table>
			</div>
		);
	}

	render() {
		const unidades = this.props.listaUnidade.filter(unidade => !unidade.valor.toUpperCase().includes('DIRETA'));
		const selecionadas = this.state.filtro.id_unidades || [];
		const produtos = this.props.listaProduto || [];
		const saldos = unidades.filter(unidade => (!selecionadas.length || selecionadas.includes(unidade.id))
			&& this.props.lista.some(item => item.id_unidade == unidade.id)).map(unidade => ({
			unidade,
			linhas: produtos.map(produto => ({ produto, ...this.calcularSaldos(unidade, produto) }))
		}));
		const totais = produtos.map(produto => saldos.reduce((total, saldo) => {
			const linha = saldo.linhas.find(item => item.produto.id == produto.id);
			return {
				produto,
				infinitum: total.infinitum + linha.infinitum,
				petroshow: total.petroshow + linha.petroshow,
				petroshowValorTotal: total.petroshowValorTotal + linha.petroshowValorTotal
			};
		}, { produto, infinitum: 0, petroshow: 0, petroshowValorTotal: 0, diferenca: 0 })).map(total => ({
			...total,
			petroshowCustoUnitario: total.petroshow > 0 ? total.petroshowValorTotal / total.petroshow : 0
		}));

		return (
			<Content>
				<div className="petroshow-dashboard" style={{ background: TOKENS.bg, margin: -16, padding: 16 }}>
					<style>{`
						.petroshow-dashboard table {
							border-collapse: separate !important;
							border-spacing: 0 !important;
							width: 100%;
							min-width: 960px;
							table-layout: fixed;
						}
						.petroshow-dashboard thead tr { background: ${TOKENS.headerGradientSoft} !important; }
						.petroshow-dashboard thead th {
							color: #f1f5f9 !important;
							font-weight: 600 !important;
							font-size: 12px !important;
							text-transform: uppercase;
							letter-spacing: .6px;
							padding: 4px 2px !important;
							border: none !important;
						}
						.petroshow-dashboard tbody tr { transition: background-color .15s ease; }
						.petroshow-dashboard tbody tr:hover { background-color: #f8fafc !important; }
						.petroshow-dashboard tbody td {
							padding: 4px !important;
							border-bottom: 1px solid ${TOKENS.border} !important;
							font-size: 14px;
							color: ${TOKENS.textPrimary};
						}
						.petroshow-dashboard .db-card {
							background: ${TOKENS.cardBg};
							border-radius: ${TOKENS.cardRadius}px;
							box-shadow: ${TOKENS.cardShadow};
							overflow: hidden;
							margin-bottom: 8px;
							border: 1px solid ${TOKENS.border};
						}
						.petroshow-dashboard .db-card-header {
							background: ${TOKENS.headerGradient};
							padding: 4px 22px;
							display: flex;
							align-items: center;
							justify-content: space-between;
						}
						.petroshow-dashboard .db-card-header label {
							color: #fff;
							font-size: 15px;
							font-weight: 600;
							letter-spacing: .2px;
							margin: 0;
						}
						.petroshow-dashboard .db-table-wrap { overflow-x: auto; }
					`}</style>
					<Select
						options={unidades}
						label='Unidade'
						cols='12 12 12 12'
						placeholder='Selecione'
						multiple={true}
						value={unidades.filter(unidade => selecionadas.includes(unidade.id)).map(item => ({ value: item.id, label: item.valor }))}
						onChange={values => this.setFiltro({ ...this.state.filtro, id_unidades: (values || []).map(item => item.value) })} />
					{saldos.map(saldo => (
						<div className="db-card" key={saldo.unidade.id}>
							<div className="db-card-header"><label>Saldos - {saldo.unidade.valor}</label></div>
							{this.renderTabela(saldo.linhas)}
						</div>
					))}
					<div className="db-card">
						<div className="db-card-header"><label>Total das Unidades</label></div>
						{this.renderTabela(totais)}
					</div>
				</div>
			</Content>
		);
	}
}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	aguardando: state.dashboardPetroshow.aguardando,
	lista: state.dashboardPetroshow.lista,
	listaTerceiro: state.dashboardPetroshow.listaTerceiro,
	listaEntrada: state.dashboardPetroshow.listaEntrada,
	listaSaida: state.dashboardPetroshow.listaSaida,
	listaTransferencia: state.dashboardPetroshow.listaTransferencia,
	listaUnidade: state.dashboardPetroshow.listaUnidade,
	listaProduto: state.dashboardPetroshow.listaProduto.filter(item => item.id == 1 || item.id == 3),
	listaPosicaoVeiculo: state.dashboardPetroshow.listaPosicaoVeiculo,
	listaManual: state.dashboardPetroshow.listaManual,
	listaManualPetroshow: state.dashboardPetroshow.listaManualPetroshow,
	listaEstoqueBase: state.dashboardPetroshow.listaEstoqueBase
});
const mapDispatchToProps = dispatch => bindActionCreators({
	getLista, getListaTerceiros, getListaEntradas, getListaSaidas, getListaTransferencias, getListaUnidade, getListaProduto, getListaPosicaoVeiculo, getListaManual, getListaEstoqueBase
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(DashboardPetroshow)
